<template>
  <v-btn :id="id" :dark="dark" :color="color == 'secondary' ? 'blue-grey darken-4' : color" class="white--text" :disabled="disabled">{{ label }}</v-btn>
</template>

<script>
  export default {
    props: {
      dark: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false
      },
      color: {
        type: String,
        default: "primary"
      },
      label: {
        type: String,
        default: '',
      },
      id: {
        type: String,
        default: '',
      }
    }
  }
</script>

<style lang='scss'>
</style>



// WEBPACK FOOTER //
// ActionButton.vue?3c3f3c8e